export function farloUiTimelineCarousel(element) {
    const elementsInView = parseInt(element.getAttribute('data-elements-in-view')) || 1.2;

    const getNumVisibleCells = () => {
        return window.innerWidth <= 992 ? 1.2 : elementsInView;
    };

    let flktyTimeline = new Flickity(element, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        freeScroll:true,
        draggable:true,
        dragThreshold: 5,
        groupCells: getNumVisibleCells(),
    });

    const onResize = () => {
        const newVisibleCells = getNumVisibleCells();
        if (flktyTimeline.options.groupCells !== newVisibleCells) {
            flktyTimeline.options.groupCells = newVisibleCells;
            flktyTimeline.destroy(); 
            flktyTimeline = new Flickity(element, {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                wrapAround: false,
                freeScroll:true,
                draggable:true,
                dragThreshold: 5,
                groupCells: newVisibleCells,
            });
        }
    };

    // Horizontal scrolling with mouse wheel, but allow vertical scrolling
    const onWheel = (event) => {
        // Check if the horizontal scroll delta (event.deltaX) is significant
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            // Prevent default scroll only when scrolling horizontally
            event.preventDefault();
            
            if (event.deltaX < 0) {
                flkty.previous();  // Scroll left (back)
            } else if (event.deltaX > 0) {
                flkty.next();  // Scroll right (forward)
            }
        }
    };

    // Add touch handling for mobile devices
    let startX, startY;

    const onTouchStart = (event) => {
        const touch = event.touches[0];
        startX = touch.pageX;
        startY = touch.pageY;
    };

    const onTouchMove = (event) => {
        const touch = event.touches[0];
        const deltaX = touch.pageX - startX;
        const deltaY = touch.pageY - startY;

        // Check if horizontal movement is larger than vertical movement
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            // Prevent vertical scrolling if it's a horizontal swipe
            event.preventDefault();
            // Move Flickity horizontally based on swipe
            if (deltaX < 0) {
                flkty.next();  // Swipe left to scroll right
            } else {
                flkty.previous();  // Swipe right to scroll left
            }
        }
        // Otherwise, let vertical scrolling proceed as normal
    };

    element.addEventListener('wheel', onWheel);
    element.addEventListener('touchstart', onTouchStart);
    element.addEventListener('touchmove', onTouchMove);

    window.addEventListener('resize', onResize);
}